// extracted by mini-css-extract-plugin
export var button = "_f8-2";
export var card = "_f8-0";
export var closeButtonContainer = "_f8-3";
export var iconContainer = "_f8-1";